import React from 'react';
import {
  Tabs,
  Tab,
} from '@mui/material';
import {
  Link, useMatches,
} from 'react-router-dom';
import { TabItem, SecondaryAppbarTabsProps } from './types';

const SecondaryAppbarTabs = ({
  tabs,
}: SecondaryAppbarTabsProps) => {
  const matches = useMatches();

  const activeTab = matches.find((match) => {
    const matchedTab = match.handle as { tab: string };
    return Boolean(matchedTab?.tab);
  }) as { handle: { tab: string } } | undefined;

  return (
    <Tabs value={activeTab?.handle.tab}>
      {tabs.map((item: TabItem) => (
        <Tab
          key={`${item.to}${item.label}`}
          component={Link}
          to={item.to}
          value={`/${item.to}`}
          disableRipple
          replace={item.replace ?? true}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            ...item.sx,
          }}
          label={(
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{item.label?.toUpperCase() || item.to.toUpperCase()}</span>
              {item.endAdornment}
            </div>
          )}
        />
      ))}
    </Tabs>
  );
};

export default SecondaryAppbarTabs;
